module.exports = __webpack_public_path__ + "04_hair_brown.e049006a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/04_hair_brown.png
// module id = HbUZ
// module chunks = 0